import React from 'react'
import { Form, Input, Button, Select } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { ComplianceType } from '../../constants'

interface RuleItemProps {
  field: any
  innerField: any
  form: any
  onRemove: (name: number) => void
}

// 单个评分细则组件
const RuleItem: React.FC<RuleItemProps> = ({ field, innerField, form, onRemove }) => {
  // 使用静态路径，通过依赖项来监听特定字段
  const allRules = Form.useWatch(['items', field.name, 'subItems'], form)
  const currentRule = allRules?.[innerField.name]
  const complianceType = currentRule?.complianceType

  return (
    <div className="compliance-form-secondary-item" key={innerField.key}>
      <Form.Item name={[innerField.name, 'complianceType']}>
        <Select className={`${complianceType === ComplianceType.violation ? 'violation-rule-type' : 'exemption-rule-type'}`}>
          <Select.Option value={ComplianceType.violation} style={{ color: '#E54C1D' }}>违规情形</Select.Option>
          <Select.Option value={ComplianceType.exemption} style={{ color: '#1990FF' }}>豁免情形</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item style={{ marginLeft: 10, width: '100%', marginBottom: 10 }} name={[innerField.name, 'description']} rules={[{ required: true, message: '请输入规则描述' }]}>
        <Input maxLength={500} placeholder={complianceType === ComplianceType.violation ? '请输入违规情形，即明确涉及违规的情形和案例，描述越详细，模型效果越好' : '请输入豁免情形，即一些不应被判断为违规的特殊情形，描述越详细，模型效果越好'} />
      </Form.Item>
      <Button
        icon={<CloseCircleOutlined />}
        type="link"
        onClick={() => onRemove(innerField.name)}
        style={{ flexShrink: 0, width: 49 }}
      />
    </div>
  )
}

interface SubItemsProps {
  field: any
  form: any
}

const SubItems: React.FC<SubItemsProps> = ({ field, form }) => {
  return (
    <Form.List name={[field.name, 'subItems']}>
      {(innerFields, { add: addInner, remove: removeInner }) => (
        <>
          {innerFields.map((innerField: any, innerIndex: number) => (
            <RuleItem
              key={innerField.key}
              field={field}
              innerField={innerField}
              form={form}
              onRemove={removeInner}
            />
          ))}
          <div style={{ margin: '0 49px 20px 80px' }}>
            <Button
              style={{ borderColor: '#1890ff', color: '#1890ff', width: '100%' }}
              onClick={() => addInner({
                'complianceType': ComplianceType.exemption,
                'description': '',
              })}
            >
              新建子项
            </Button>
          </div>
        </>
      )}
    </Form.List>
  )
}

export default SubItems
